// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__LLayF","busy":"Header_busy__2zimp","time":"Header_time__37g0E","title":"Header_title__2q_57","buttons":"Header_buttons__7UFJ4"};